export default function ExpenseForm({ children }) {
  return <div className="income">{children}</div>;
}
